import { callApi } from '@/api/apibase'

export const getCourseLocations  = function (courseId) {
  return callApi('GET', `/api/external/greencourse/CourseLocations/${courseId}`, null)
}
